import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { DESKTOP, TABLET_PORTRAIT, XX_LARGE } from 'src/client/constants/mediaQueries';

import { useShowSfwSite } from 'src/client/helpers/useFeatureFlags';
import { useSelector } from 'src/client/redux';
import styled from 'styled-components/macro';
import { BackgroundVideo } from './VideoIntro';

export const VideoBanner = () => {
  const { contentCdnUrl } = useSelector((state) => state.app);
  const site = useSelector((state) => state.site);
  const showSfwSite = useShowSfwSite();
  const sitePickerIcon = useSelector((state) => state.app.icons?.sitePicker);

  const videoSuffix = showSfwSite ? '-sfw' : '';
  const baseVideoPath = `${contentCdnUrl}/${site.UUID}/media/static-splash`;

  return (
    <Wrapper>
      <BackgroundVideo autoPlay loop muted playsInline>
        <source
          src={`${baseVideoPath}/bottom-banner${videoSuffix}.mp4`}
          // Safari >17.5 has a bug looping .webm, the codec here should only work in Safari
          type={'video/mp4; codecs="hvc1"'}
          media="(min-width: 768px)"
        />
        <source
          src={`${baseVideoPath}/bottom-banner${videoSuffix}.webm`}
          type="video/webm"
          media="(min-width: 768px)"
        />
        <source src={`${baseVideoPath}/bottom-banner${videoSuffix}.mp4`} type="video/mp4" media="(min-width: 768px)" />
      </BackgroundVideo>
      <CenterContainer>
        <CenterLogo icon={sitePickerIcon} />
        <FlavorText>WHERE FLAWLESS BEAUTY MEETS ART</FlavorText>
      </CenterContainer>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  aspect-ratio: 1440 / 360;
  position: relative;
  width: 100%;
  overflow: hidden;
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media ${TABLET_PORTRAIT} {
    display: flex;
  }
`;

const CenterContainer = styled.div`
  position: absolute;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
`;

const CenterLogo = styled(FontAwesomeIcon)`
  position: absolute;
  font-size: 90px;
  color: ${(props) => props.theme.primaryBtn1Bg};
  opacity: 0.2;

  @media ${DESKTOP} {
    font-size: 170px;
  }

  @media ${XX_LARGE} {
    font-size: 300px;
  }
`;

const FlavorText = styled.span`
  position: absolute;
  font-size: 10px;
  color: ${(props) => props.theme.primaryBtn1Bg};

  @media ${DESKTOP} {
    font-size: 18px;
  }

  @media ${XX_LARGE} {
    font-size: 32px;
  }
`;
